import { Routes } from '@angular/router';
import { BuilderComponent } from './layouts/builder/builder.component';
import { Demo1Component } from './layouts/demo1/demo1.component';
import { IndexComponent as Demo1IndexComponent } from './pages/demo1/index/index.component';
import { InvoiceListComponent } from './feature/entitylist/entity-list-page.component';
import { MasterDynamicAppList } from './pages/masterentitylist/dynamicentity-list-page.component';
import { TransDynamicAppList } from './pages/transentitylist/dynamicentity-list-page.component';
import { DynamicFormPageComponent } from './feature/masterentityform/dynamic-form-page/dynamic-form-page';
import { TransDynamicFormPageComponent } from './feature/transentityform/dynamic-form-page/dynamic-form-page';
import { TransDynamicFormPagee } from './pages/transentitylist/transentityform/dynamic-form-page/dynamic-form-page';
import { ValidationManagerComponent } from './pages/demo1/validation-manager/validation-manager.component';
import { ListConfigComponent } from './pages/demo1/metalist-manager/metalist-manager.component';
import { LookupManagerComponent } from './pages/demo1/lookup-manager/lookup-manager.component';
import { WorkflowDesignerComponent } from './pages/demo1/workflow-manager/workflow-designer.component';
import { UserComponent } from './pages/demo1/user-manager/user.component';
import { LoginComponent } from './pages/auth/login/login.component';
import { TwofaSetupComponent } from './pages/auth/twofa-setup/twofa-setup.component';
import { AuthGuard } from './guards/auth.guard';
import { VerifyOtpComponent } from './pages/auth/verify-otp/verify-otp.component';
import { OtpComponent } from './pages/auth/otp/otp.component';
import { MetaComponent } from './pages/demo1/meta-entity manager/meta-entity.component';
import { MetaUiComponent } from './pages/demo1/meta-ui manager/meta-ui.component';
import { MetaFieldComponent } from './pages/demo1/meta-field manager/meta-field.component';
import { RolePermissionComponent } from './pages/demo1/permission-manager/role-permission.component';
import { MenuPermissionComponent } from './pages/demo1/menu_manager/menu-permission.component';
import { MetaManagementComponent } from './pages/demo1/meta-management/meta-management.component';
import { MetaSyncManagerComponent } from './pages/demo1/meta-sync-manager/meta-sync.component';
import { EntityActionMapComponent } from './pages/demo1/entityActoinSpManager/entity-action-map.component';
import { RenderEntityListPageComponent } from './pages/renderentitylist/renderentity-list-page.component';
import { RenderFormPageComponent } from './pages/renderentitylist/renderentityform/render-form-page';
import { SysNumberSequenceComponent } from './pages/demo1/documnet-number-sequence/sys-number-sequence.component';
import { TaxGroupComponent } from './pages/demo1/tax-group-manager/tax-group.component';


export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  /*
    PUBLIC ROUTES
    */

  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'security/2fa',
    component: TwofaSetupComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'verify-otp',
    component: VerifyOtpComponent
  },
  {
    path: 'otp',
    component: OtpComponent
  },

  /*
  PROTECTED ROUTES
  */

  {
    path: 'builder',
    component: BuilderComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'app',
    component: Demo1Component,
    canActivateChild: [AuthGuard],
    children: [
      { path: '', component: Demo1IndexComponent },
      //  {
      // path: 'invoices',
      // component: InvoiceListComponent
      // },

      // {
      //   path: 'general/master/:entity/:id',
      //   component: DynamicFormPageComponent,
      // },
      // {
      //   path: 'general/master/:entity',
      //   component: MasterDynamicAppList,
      // },
      // {
      //   path: 'general/trans/:entity',
      //   component: TransDynamicAppList,
      // },
      // {
      //   path: 'general/trans/add/:entity',
      //   component: TransDynamicFormPagee,
      // },
      // {
      //   path: 'general/trans/update/:entity/:id',
      //   component: TransDynamicFormPagee,
      // },

      // {
      //   path: 'general/trans/:entity',
      //   component: RenderEntityListPageComponent,
      // },

      //master entity routes (Fix: Updated to match the new RenderFormPageComponent and RenderEntityListPageComponent)
      {
        path: ':module/master/:entity',
        component: RenderEntityListPageComponent,
      },
      {
        path: ':module/master/:entity/new',
        component: RenderFormPageComponent,
      },
      {
        path: ':module/master/:entity/:id',
        component: RenderFormPageComponent,
      },

      //Transactional Entity Routes (Fix: Updated to match the new RenderFormPageComponent and RenderEntityListPageComponent)
      {
        path: ':module/trans/:entity',
        component: RenderEntityListPageComponent,
      },
      {
        path: ':module/trans/:entity/new',
        component: RenderFormPageComponent,
      },
      {
        path: ':module/trans/:entity/:id',
        component: RenderFormPageComponent,
      },

      //   {
      //     path: 'form/:entity',
      //     component: DynamicFormPageComponent
      //   },

      // {
      //   path: 'general/trans/:entity/:id',
      //   component: TransDynamicFormPageComponent,
      // },

      //Config Routines
      {
        path: 'lookup-manager',
        component: LookupManagerComponent,
      },
      {
        path: 'validation-rules',
        component: ValidationManagerComponent,
      },
      {
        path: 'listconfing-manager',
        component: ListConfigComponent,
      },
      {
        path: 'sys/workflow-designer',
        component: WorkflowDesignerComponent
      },
      {
        path: 'sys/workflow-designer/:id',
        component: WorkflowDesignerComponent
      },
      {
        path: 'usermanager',
        component: UserComponent
      },
      {
        path: 'metaentity-manager',
        component: MetaComponent
      },
      {
        path: 'metaui-manager',
        component: MetaUiComponent
      },
      {
        path: 'metafield-manager',
        component: MetaFieldComponent
      },
      {
        path: 'role-manager',
        component: RolePermissionComponent
      },
      {
        path: 'menu-manager',
        component: MenuPermissionComponent
      },
      {
        path: 'meta-manager',
        component: MetaManagementComponent
      },
      {
        path: 'metaSync-manager',
        component: MetaSyncManagerComponent
      },
      {
        path: 'mapping',
        component: EntityActionMapComponent
      },
      {
        path: 'documetnNumberSequence',
        component: SysNumberSequenceComponent
      },
      {
        path: 'taxGroupManager',
        component: TaxGroupComponent
      },
      //   {
      //     path: 'category',
      //     component: CategoryListComponent
      //   },
    ],
  }
];
